export default "__VITE_ASSET__Dl6yTi6Z__"